import { FC } from 'react'

interface Props {
  cardType: string
  last4: string
  handleModalChange: () => void
}

const BillingInfo: FC<Props> = ({ cardType, last4, handleModalChange }) => {
  return (
    <article data-container="billing-info">
      <span>Billing information</span>
      <p>
        {cardType} ending in {last4}
      </p>
      <button onClick={handleModalChange} className="outline">
        Edit Billing Information
      </button>
    </article>
  )
}

export default BillingInfo
